module.exports = __webpack_public_path__ + "static/2-2ad2ef914f84c10a219d669ca6e5b017.jpg";